<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'department.schedule.title' | translate }} - {{departament?.name}}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="row g-3">
          
          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'monday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="mondaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="mondaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.monday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'tuesday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="tuesdaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="tuesdaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.tuesday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'wednesday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="wednesdaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="wednesdaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.wednesday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'thursday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="thursdaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="thursdaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.thursday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'friday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="fridaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="fridaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.friday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'saturday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="saturdaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="saturdaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.saturday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-4" [formGroupName]="'sunday'">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                  <div class="custom-switch mb-2">
                    <input 
                      type="checkbox" 
                      id="sundaySwitch" 
                      data-switch="success" 
                      formControlName="actived"
                      tabindex="0"
                    />
                    <label for="sundaySwitch">
                      <span class="d-block fw-bold">
                        {{ 'department.schedule.sunday' | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label small">{{ 'department.schedule.openingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="startTime" [placeholder]="'department.schedule.openingPlaceholder' | translate">
                </div>
                <div class="mb-2">
                  <label class="form-label small">{{ 'department.schedule.closingTime' | translate }}</label>
                  <input type="text" class="form-control" [mask]="'00:00'" formControlName="endTime" [placeholder]="'department.schedule.closingPlaceholder' | translate">
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'department.schedule.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ (isNew ? 'department.schedule.save' : 'department.schedule.update') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>